
import "./Checkbox.css";
interface CheckboxProps {
   type: boolean; // Ensure the 'type' prop is a boolean
   onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
   name?: string;
   id: string;

}
const Checkbox: React.FC<CheckboxProps> = ({ type, onChange, name, id }) => {
   return (
      <div className="checkbox-wrapper-19">
         <input id={id} type="checkbox" name={name} checked={type} onChange={onChange} />
         <label className="check-box" htmlFor={id} />
      </div>
   )
};


export default Checkbox;